import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDStack } from '@facet-wealth/design';
import QuickEditPicker from './QuickEditPicker';
import TitleWithIcon from './TitleWithIcon';
import StatList from './StatList';
import OutcomeInsightPicker from './OutcomeInsightPicker';
import OutcomeSummaryKabobMenu from './OutcomeSummaryKabobMenu';

const Summary = ({ resource }) => {
  return (
    <FDBox width="100%">
      <FDStack justifyContent="space-between" alignItems="center">
        <TitleWithIcon icon={resource.attr('iconType')} title={resource.attr('title')} />
        <StatList summaryItems={resource.attr('primarySummaryItems')} />
        <OutcomeInsightPicker resource={resource} />
        <FDStack alignItems="center" justifyContent="flex-start">
          <QuickEditPicker resource={resource} />
          <OutcomeSummaryKabobMenu resource={resource} />
        </FDStack>
      </FDStack>
    </FDBox>
  );
};

Summary.defaultProps = {};

Summary.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default Summary;
